import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import VerticalSlider from '~/components/Sliders/VerticalSlider';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import { imageSecondaryAmountState } from '~/state/atoms/image/imageAtoms';
import { OverlayLabel, OverlayRow } from '../../OverlayLabel';
import PetFusionColorSelector from './PetFusionColorSelector';

export const PetBlendingLabel = () => {
    const [imageSecondaryAmount] = useRecoilState(imageSecondaryAmountState);
    const petOpacity = 100 - imageSecondaryAmount;

    return (
        <OverlayRow sx={{ alignItems: 'center', px: 0.25, ml: -0.25 }}>
            <OverlayLabel>PET</OverlayLabel>
            <OverlayLabel color="primary.main">{petOpacity}%</OverlayLabel>
            <PetFusionColorSelector />
        </OverlayRow>
    );
};

export const PetBlendSlider = () => {
    const intl = useIntl();
    const { updatePrimaryImageAlpha } = useViewportEnvironment();
    const [imageSecondaryAmount, setImageSecondaryAmount] = useRecoilState(
        imageSecondaryAmountState
    );
    const petOpacity = 100 - imageSecondaryAmount;

    const handleOpacityChange = (_: Event, newValue: number | number[]) => {
        const value = newValue as number;
        const envAlpha = 100 - value;
        setImageSecondaryAmount(envAlpha);
        updatePrimaryImageAlpha(envAlpha);
    };

    return (
        <VerticalSlider
            key="petOpacity"
            value={petOpacity}
            onChange={handleOpacityChange}
            min={0}
            max={100}
            valueLabelFormatter={(v) => `${v}%`}
            aria-label={intl.formatMessage({ id: 'petOpacity' })}
        />
    );
};
